<template>
  <div>
    <HeraFormInput
      key="points-for-win-field"
      v-model="pointsForWin"
      v-validate="'required|numeric|decimal:0|min_value:0'"
      :label="$$t('Number of points for win:', 'points-for-win')"
      required
      size="2"
      class="tie-points-input"
      :class="{ 'is-invalid': errors.first('points-for-win') }"
      :view-mode="disabled"
      :disabled="isStageFieldDisabled('pointsForWin') || disabled"
      name="points-for-win"
      :error="errors.first('points-for-win')"
    />
  </div>
</template>

<script>
import { translate } from '@/mixins/translate';
import HeraFormInput from '@/components/atoms/form/HeraFormTextInput';
import stageSetupHelpers from '@/views/tournaments/management/singleTournament/mixins/stageHelpers';
import { prop } from '@/utils/factories';
export default {
  name: 'StagePointsForWinSetting',
  components: {
    HeraFormInput,
  },
  inject: ['$validator'],
  mixins: [translate('_web_tournament_stage-editor'), stageSetupHelpers],
  props: {
    disabled: prop(Boolean),
  },
  computed: {
    pointsForWin: {
      get() {
        return this.getBlockConfigurationByKey('points_win');
      },
      set(newVal) {
        this.setBlockConfigurationByKey('points_win', newVal);
      },
    },
  },
};
</script>

<style></style>
